export const environment = {
  production: false,
  ApiUrl:'https://api-edito.maxula-travel.solutionsplus.ovh/api',
  LoginUrl:'/login',
  MidOfficeUrl:'https://front-midoffice.maxula-travel.solutionsplus.ovh',
  debug : true,
  activeEnvironment:'development'

};
